import { render, staticRenderFns } from "./solveSonsultList.vue?vue&type=template&id=6896459e&scoped=true"
import script from "./solveSonsultList.vue?vue&type=script&lang=js"
export * from "./solveSonsultList.vue?vue&type=script&lang=js"
import style0 from "./solveSonsultList.vue?vue&type=style&index=0&id=6896459e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6896459e",
  null
  
)

export default component.exports